import * as React from "react";
import { Link } from "gatsby";
import UserIcon from "./user-icon";
import PersonButton from "../persons/person-button";

function UserButton({
  user,
  showLastName = false,
  showIcon = true,
  small = true,
  ...props
} = {}) {
  const hasPage = user?.fields?.hasPage || false;
  let className =
    "user-button btn btn-outline-primary p-0 d-inline-flex align-items-center rounded-5 override-stretched-link";
  if (small) className += " btn-sm";
  const name = showLastName
    ? `${user.first_name} ${user.last_name}`
    : user.first_name;
  return !hasPage ? (
    <PersonButton person={{ name: name }} small={small} />
  ) : (
    <Link to={user?.fields?.path} className={className} {...props}>
      {!showIcon || !user.thumbnail ? null : <UserIcon user={user} />}
      <span className={`text-nowrap ${user.thumbnail ? "ms-1 me-2" : "mx-1"}`}>
        {!showLastName
          ? user.first_name
          : `${user.first_name} ${user.last_name}`}
      </span>
    </Link>
  );
}

export default UserButton;
